import { ReactElement } from 'react';

import { ConfidentialResourceAccessRequest } from '@dreryk/egabinet-medical-data-confidentiality-frontend-api';

import {
   createInterpolatedTranslationKey,
   practitionerNameFormatter,
   Translate,
   useTranslateDeclension,
} from '@dreryk/react-common';

import { systemActivityTranslationKeys } from '../../translations';

import { isMedicalDocumentationGeneration } from './ResourceTypeCell.utils';

type DataAuthorCellProps = {
   request: ConfidentialResourceAccessRequest;
};

export const DataAuthorCell = (props: DataAuthorCellProps): ReactElement | null => {
   const { request } = props;
   const { confidentialResources } = request;

   const uniqueAuthorsCount = new Set(confidentialResources.map((resource) => resource.owner.id.asNumber())).size;

   const authorSuffix = useTranslateDeclension(
      uniqueAuthorsCount || 1,
      systemActivityTranslationKeys.dataAuthorAccusative,
      systemActivityTranslationKeys.dataAuthorPlural,
      systemActivityTranslationKeys.dataAuthorPlural
   );

   if (confidentialResources.length === 0) {
      return null;
   }

   if (confidentialResources.length === 1 && !isMedicalDocumentationGeneration(request)) {
      return <>{practitionerNameFormatter(confidentialResources[0].owner)}</>;
   }

   return (
      <Translate>
         {createInterpolatedTranslationKey(systemActivityTranslationKeys.dataAuthorsCount, {
            count: String(uniqueAuthorsCount),
            suffix: authorSuffix,
         })}
      </Translate>
   );
};
